import { AsurionLogo } from "./AsurionLogo";

export function AsurionWorkspaceLogo() {
    return <AsurionLogo />;
}
